<template>
  <div id="mb-presentation">
    <div
      id="mb-presentation-scalable"
      class="mb-presentation-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scalePres + ')',
      }"
    >
      <div
        class="mbpresentation"
        tabindex="1"
        ref="mbpresentation"
        @keyup.right="pressNext"
        @keyup.left="pressPrev"
        @keyup.esc="galeryOff()"
        :style="[
          {
            background: appConfig.mainBcg ? appConfig.mainBcg + '!important' : 'white' + '!important',
            fontFamily: appConfig.font,
          },
          additionalStyle,
        ]"
      >
        <transition name="index-fade">
          <index-list
            @setstep="goToStep"
            :color="appConfig.mainColor"
            :contrast-color="appConfig.contrastColor"
            :indexs="steps"
            v-if="showIndexBook && !autoPlayState"
          ></index-list>
        </transition>
        <transition name="info-fade">
          <first-step
            @firsstepoff="firstStepGoOut()"
            :main-color="appConfig.mainColor"
            :items="appConfig.firstStep"
            :desc="appConfig.desc"
            v-if="firsStep"
          ></first-step>
        </transition>
        <transition name="info-fade">
          <img
            v-if="currentSlide == 'Start' && appConfig.bcg"
            :src="giveMePathPlease(appConfig.bcg)"
            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"
          />
        </transition>
        <transition name="info-fade">
          <img
            :src="setLogo()"
            style="
              width: calc(1920px * 0.05);
              position: absolute;
              bottom: calc(1080px * 0.01);
              right: calc(1080px * 0.01);
            "
          />
        </transition>
        <transition name="info-fade">
          <img
            v-if="appConfig.bcg"
            src="./awesomeStuff/awesomeSvg/assets/img_02.png"
            style="
              width: calc(1920px * 0.12);
              position: absolute;
              bottom: calc(1080px * 0.01);
              left: calc(1080px * 0.01);
            "
          />
        </transition>
        <div style="width: 1820px; height: 1023px; position: absolute; top: 34px; left: calc((1920px - 1820px) / 2)">
          <impress-viewport
            v-if="!endClass"
            ref="impress"
            :steps="steps"
            :config="config"
            @goToStepNow="goToStepPlease"
            @mainAudioStateCheck="mainAudioState"
            :style="[!endClass ? { opacity: 1 } : { opacity: 0 }]"
            style="transition: 0.5s; transform: scale(1) !important"
          ></impress-viewport>
        </div>
        <transition name="big-fade">
          <div id="curtain" v-if="endClass && !firsStep">
            <div
              class="pptVersion"
              :class="{ pptVersionNoExtend: !appConfig.extend }"
              id="nomalVersion"
              v-if="endClass"
              :style="{ borderColor: appConfig.mainColor || '#309de4' }"
              @click="pleaseLetMeChooseTheVersion(false, false)"
            >
              <h2 :style="{ color: appConfig.mainColor || '#309de4' }">
                Prezentacja
                <br />multimedialna
              </h2>
            </div>
            <div
              class="pptVersionExtend"
              id="nomalVersion"
              v-if="endClass && appConfig.extend"
              :style="{ borderColor: appConfig.mainColor || '#309de4' }"
              @click="pleaseLetMeChooseTheVersion(false, true)"
            >
              <h2 :style="{ color: appConfig.mainColor || '#309de4' }">
                Prezentacja
                <br />multimedialna <br />rozszerzona
              </h2>
            </div>
            <div
              class="pptVersion"
              :class="{ pptVersionNoExtend: !appConfig.extend }"
              id="automaticVersion"
              v-if="endClass"
              :style="{ borderColor: appConfig.mainColor || '#309de4' }"
              @click="pleaseLetMeChooseTheVersion(true, false)"
            >
              <h2 :style="{ color: appConfig.mainColor || '#309de4' }">Animacja</h2>
            </div>
            <div
              class="pptVersionExtend"
              id="automaticVersion"
              v-if="endClass && appConfig.extend"
              :style="{ borderColor: appConfig.mainColor || '#309de4' }"
              @click="pleaseLetMeChooseTheVersion(true, true)"
            >
              <h2 :style="{ color: appConfig.mainColor || '#309de4' }">
                Animacja
                <br />rozszerzona
              </h2>
            </div>
          </div>
        </transition>
        <div
          id="curtainAutoPlay"
          v-if="autoPlayState"
          style="width: 100%; height: 100%; background: transparent; position: fixed; top: 0; right: 0; z-index: 1190"
        ></div>

        <helper
          v-if="!appConfig.noHelper"
          :end-class="endClass"
          :secondary-color="appConfig.secondaryColor"
          :contrast-color="appConfig.contrastColor"
          :main-color="appConfig.mainColor"
          :people-list="appConfig.helper"
          :img-list="appConfig.helperImg"
          :auto-play-state="autoPlayState"
          :hidden-icons="appConfig.hiddenIcons"
        ></helper>
        <div style="position: absolute; top: 0; right: 0; z-index: 2190">
          <transition name="info-fade">
            <div
              id="exitControll"
              class="icon"
              style="z-index: 2190"
              v-if="!galeryOpen"
              @mouseenter="hoverControllClose = true"
              @mouseleave="hoverControllClose = false"
            >
              <svg width="100%" height="100%" @click="closePresentation()" viewBox="0 0 24 24">
                <path
                  class="white"
                  :style="[hoverControllClose ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor }]"
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                />
              </svg>
            </div>
          </transition>
        </div>
        <div style="position: absolute; top: 0; right: 108px; z-index: 1190">
          <transition name="info-fade">
            <svg
              class="comicIcon icon"
              v-if="checkComic() && currentSlide != 'Start' && !autoPlayState && !endClass"
              viewBox="0 0 24 24"
              width="calc(1080px * 0.05)"
              height="calc(1080px * 0.05)"
              @click="comicInteraction(mainBind)"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <transition name="info-fade">
                <path
                  class="showComicTrue white"
                  :style="[hoverControllMain ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor }]"
                  v-if="!showComic"
                  d="m20,1.91736l-16,0c-1.1,0 -1.99,0.9 -1.99,2l-0.01,18l4,-4l14,0c1.1,0 2,-0.9 2,-2l0,-12c0,-1.1 -0.9,-2 -2,-2z"
                />
              </transition>
              <transition name="info-fade">
                <path
                  class="showComicFalse white"
                  :style="[hoverControllMain ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor }]"
                  v-if="showComic"
                  d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
                />
              </transition>
            </svg>
          </transition>
          <transition name="info-fade">
            <svg
              v-if="stepsAudio && currentSlide != 'Start' && !autoPlayState && !endClass"
              class="audioIcon icon"
              viewBox="0 0 24 24"
              width="calc(1080px * 0.05)"
              height="calc(1080px * 0.05)"
              @click="stepAudioSetMuteValue()"
              @mouseenter="hoverControllMainAudio = true"
              @mouseleave="hoverControllMainAudio = false"
            >
              <transition name="info-fade">
                <path
                  class="showAudioFalse white"
                  v-if="audioVisibleMute"
                  :style="[
                    hoverControllMainAudio ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                  ]"
                  d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                />
              </transition>
              <transition name="info-fade">
                <path
                  class="showAudioTrue white"
                  :style="[
                    hoverControllMainAudio ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                  ]"
                  v-if="!audioVisibleMute"
                  d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                />
              </transition>
            </svg>
          </transition>
          <transition name="info-fade">
            <div
              class="mainAudioControll icon"
              v-if="!endClass && appConfig.mainSound"
              style="z-index: 1190"
              :style="[
                autoPlayState || appConfig.noIndexList
                  ? { right: 'calc(1080px * 0.15)' }
                  : { right: 'calc(1080px * 0.2)' },
              ]"
            >
              <svg
                width="100%"
                height="100%"
                @click="mainAudioControll(!mainAudioControl)"
                viewBox="0 0 24 24"
                @mouseenter="hoverControllAudio = true"
                @mouseleave="hoverControllAudio = false"
              >
                <transition name="info-fade">
                  <path
                    id="mainAudioControllmuted"
                    class="white"
                    v-if="!mainAudioControl"
                    :style="[
                      hoverControllAudio ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                    ]"
                    d="M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3zM14 7h4V3h-6v5.18l2 2z"
                  />
                </transition>
                <transition name="info-fade">
                  <path
                    v-if="mainAudioControl"
                    class="white"
                    :style="[
                      hoverControllAudio ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                    ]"
                    d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
                  />
                </transition>
              </svg>
            </div>
          </transition>
          <transition name="info-fade">
            <div
              class="indexControl icon"
              v-if="!endClass && !autoPlayState && steps.length > 1 && !(appConfig.noIndexList == true)"
              style="z-index: 1190"
            >
              <svg
                viewBox="0 0 24 24"
                width="calc(1080px * 0.05)"
                height="calc(1080px * 0.05)"
                @click="showIndexBook = !showIndexBook"
                @mouseenter="hoverControllIndex = true"
                @mouseleave="hoverControllIndex = false"
              >
                <transition name="info-fade">
                  <path
                    class="white"
                    :style="[
                      hoverControllIndex ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                    ]"
                    v-if="!showIndexBook"
                    d="M13,9.5H18V7.5H13V9.5M13,16.5H18V14.5H13V16.5M19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21M6,11H11V6H6V11M7,7H10V10H7V7M6,18H11V13H6V18M7,14H10V17H7V14Z"
                  />
                </transition>
                <transition name="info-fade">
                  <path
                    class="white"
                    :style="[
                      hoverControllAudio ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                    ]"
                    v-if="showIndexBook"
                    d="M13,7.5H18V9.5H13V7.5M13,14.5H18V16.5H13V14.5M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M19,19V5H5V19H19M11,6V11H6V6H11M10,10V7H7V10H10M11,13V18H6V13H11M10,17V14H7V17H10Z"
                  />
                </transition>
              </svg>
            </div>
          </transition>
          <transition name="info-fade">
            <div
              class="resetControl icon"
              v-if="!endClass && !appConfig.noReset"
              style="z-index: 1190"
              @mouseenter="hoverControllReset = true"
              @mouseleave="hoverControllReset = false"
            >
              <svg width="100%" height="100%" @click="forceReset()" viewBox="0 0 24 24">
                <transition name="info-fade">
                  <path
                    :style="[
                      hoverControllReset ? { fill: appConfig.secondaryColor } : { fill: appConfig.contrastColor },
                    ]"
                    id="resetIcon"
                    class="white"
                    d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                  />
                </transition>
              </svg>
            </div>
          </transition>
        </div>

        <div class="top-nav" style="z-index: 1100" :style="{ background: appConfig.mainColor || '#309de4' }"></div>
        <transition name="go-up">
          <div
            v-if="appConfig.desc && endClass"
            class="top-nav-small"
            style="z-index: 1000"
            :style="{
              background: appConfig.mainColor + 'B3' || '#309de4B3',
              color: appConfig.contrastColor || 'white',
            }"
          >
            <span v-html="appConfig.desc"></span>
          </div>
        </transition>

        <!-- <div
        id="mainControlls"
        v-if="currentSlide != 'Start' && !autoPlayState && !endClass"
        style="z-index: 1190; text-align: right"
        :style="[
          appConfig.mainSoundStatus == 'off' || appConfig.noIndexList ? { right: 'calc(1080px * 0.20)' } : {},
          appConfig.mainSoundStatus == 'off' && appConfig.noIndexList ? { right: 'calc(1080px * 0.15)' } : {},
        ]"
        ></div>-->
        <div id="navigation" v-if="!endClass">
          <!-- <img draggable="false" src="~@/assets/icons/menuSpis-OFF.png" style="margin-top: -5vh" /> -->
          <div
            class="ballBox"
            :key="slide + index"
            v-for="(slide, index) in steps"
            :id="'navigation-step-' + index"
            :style="[slide.id == 'skip' ? { display: 'none' } : {}]"
          >
            <div class="ball" @click="goToStep(slide.id, index)">
              <transition name="info-fade">
                <div
                  class="trueBall"
                  v-if="currentSlide == slide.id"
                  :style="{ background: appConfig.mainColor || '#0054a3' }"
                ></div>
              </transition>
            </div>
          </div>
        </div>
        <svg
          v-if="!endClass && !autoPlayState && slides2.length > 1"
          width="calc(1080px * 0.1)"
          id="next"
          height="calc(1080px * 0.1)"
          viewBox="0 0 400 400"
          @click="pressNextClick"
        >
          <g>
            <rect id="canvas_background" fill="transparent" height="402" width="402" y="-1" x="-1" />
          </g>
          <g>
            <ellipse
              id="svg_9"
              :stroke="appConfig.mainColor || '#0054a3'"
              ry="156"
              rx="156"
              cy="199"
              cx="199"
              fill-opacity="0"
              stroke-width="29"
              :fill="appConfig.mainColor || '#0054a3'"
            />
            <path
              class="path"
              id="svg_12"
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="appConfig.mainColor || '#0054a3'"
              :stroke="appConfig.mainColor || '#0054a3'"
            />
          </g>
        </svg>
        <svg
          v-if="!endClass && !autoPlayState && slides2.length > 1"
          width="calc(1080px * 0.1)"
          id="prv"
          height="calc(1080px * 0.1)"
          viewBox="0 0 400 400"
          @click="pressPrevClick"
        >
          <g>
            <rect id="canvas_background" fill="transparent" height="402" width="402" y="-1" x="-1" />
          </g>
          <g>
            <ellipse
              id="svg_9"
              :stroke="appConfig.mainColor || '#0054a3'"
              :fill="appConfig.mainColor || '#0054a3'"
              ry="156"
              rx="156"
              cy="199"
              cx="199"
              fill-opacity="0"
              stroke-width="29"
            />
            <path
              class="path"
              id="svg_12"
              :stroke="appConfig.mainColor || '#0054a3'"
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="appConfig.mainColor || '#0054a3'"
            />
          </g>
        </svg>
        <transition name="big-fade">
          <img-to-show v-if="galeryOpen"></img-to-show>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import imgToShow from './awesomeStuff/awesomeBoxInTheBox/imgToShow';
import helper from './awesomeStuff/helpBox/helper';
import baseBoxWithIf from './awesomeStuff/baseBoxWithIf';
import indexList from './awesomeStuff/indexList/indexList.vue';
import firstStep from './awesomeStuff/firstStep/firstStep.vue';
import { Howl } from 'howler';
export default {
  components: { imgToShow, indexList, firstStep, helper },
  created() {
    window.addEventListener('resize', this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  methods: {
    giveMePathPlease(path) {
      // console.log(path);
      if (path) {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      }
    },
    resizeWindow(e) {
      let itm = document.getElementById('mb-presentation').getBoundingClientRect();
      console.log(this.$route.name);
      if (this.$route.name == 'main-view') {
        this.scalePres = 1;
      } else this.scalePres = Math.min(itm.width / 1920, itm.height / 1080);
    },
    setWidthScale() {
      let itm = document.getElementById('mb-presentation').getBoundingClientRect();
      // console.log(itm);
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-presentation').getBoundingClientRect();
      // console.log(itm);
      return itm.height / 1080;
    },
    setAutoAudioRun(state) {
      this.autoAudioRun = state;
    },
    firstStepGoOut() {
      this.firsStep = false;
      if (this.appConfig.noAnimation) {
        this.pleaseLetMeChooseTheVersion(false, false);
      }
    },
    goToStepPlease(i) {
      let stepClear = this.clearStepsData[i];
      setTimeout(() => {
        this.goToStep(stepClear.name, stepClear.id);
      }, 50);
    },
    setLogo() {
      if (this.appConfig?.isLogo) {
        if (this.appConfig.logo) {
          return this.giveMePathPlease(this.appConfig.logo);
        } else {
          return require('./awesomeStuff/awesomeSvg/assets/logo.png');
        }
      }
    },
    closePresentation() {
      if (this.stepsAudio) {
        this.stepsAudio.stop();
      }
      if (this.stepsAudio) {
        this.stopSound();
      }
      // if (this.$route.name == 'presentation') {
      //   this.$router.push('/page/grid');
      // }
      this.mainAudioControll(false);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', false);
      this.$store.commit('STATE_SET_GALERY_OPEN', false);
      this.$store.commit('STATE_PRESENTATION_SHOW', false);
      setTimeout(() => {
        if (this.prevRoute) {
          console.log(this.prevRoute);
          if (this.prevRoute.fullPath == '/grid') {
            Howler.stop();
            this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
          }
          if (this.prevRoute.fullPath.includes('page')) {
            Howler.stop();
            this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
          }
        } else {
          window.history.back();
        }
      }, 100);
    },
    hoverOn(state) {
      this.hoverOnPower = state;
    },
    galeryOff() {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', false);
      this.$store.commit('STATE_SET_GALERY_OPEN', false);
      this.$store.commit('STATE_PRESENTATION_SHOW', false);
    },
    forceReset() {
      this.$store.commit('STATE_AUDIO', false);
      if (this.stepsAudio) {
        this.stepsAudio.stop();
      }
      this.canIClick = true;
      this.stepsAudio = null;
      this.setAutoAudioRun(true);
      this.showIndexBook = false;
      this.endClass = true;
      this.autoPlayState = false;
      this.$store.commit('STATE_AUDIO', false);
      this.mainAudioControl = true;
      this.firsStep = true;
      this.mainAudioControll(true);
      this.showIndexBook = false;
      //location.reload();
      this.goToStep(this.steps[0].id, 0);
    },
    impressPrevStep() {
      if (this.sorryMasterCanIGoToOtherSlide) {
        this.stopSound();
        this.slideToGo();
        // let tmpAudioStatus = this.audioVisible;
        if (this.stepsAudio && !this.autoPlayState) {
          this.stepsAudio.stop();
        }
        this.audioVisibleMute = false;
        this.$refs.impress.prevStep();
        if (!this.autoPlayState && this.stepsAudio) {
          setTimeout(() => {
            // this.playSound();

            this.stepsAudioController();
          }, 1500);
        }
        this.$store.commit('STATE_SET_CURRENT_STEP', this.$refs.impress.stepClass);
        this.createSound();
        // if (this.stepsAudio) {
        //   if (!this.stepsAudio.playing()) {
        //     this.stepsAudio.play();
        //   }
        // }
        this.$store.commit('STATE_COMIC_SHOW', false);
        this.$store.commit('STATE_AUDIO_WAIT', false);
        if (this.currentSlide == 'skip') {
          setTimeout(() => {
            this.impressPrevStep();
          }, 1101);
        }
      }
    },
    mainAudioControll(state) {
      if (this.appConfig.mainSound) {
        if (state) {
          this.mainAudioControl = state;
          // let audio = document.getElementById("mainAudio");
          this.sound.play();
          console.log('SOUND PLAY');
          // audio.volume = this.volume;
          // this.sound.fade(0, 0.05, 1000);
        } else {
          this.mainAudioControl = state;
          // let audio = document.getElementById("mainAudio");
          this.sound.pause();
          console.log('SOUND STOP');
          // audio.volume = this.volume;
          // this.sound.fade(0.05, 0, 1000);
        }
      }
    },
    mainAudioState(value) {
      if (this.sound) {
        if (value) {
          if (this.sound.playing()) this.sound.pause();
        } else {
          if (this.mainAudioControl) {
            this.sound.play();
          }
        }
      }
      // if (this.stepsAudio) {
      //   if (value) {
      //     if (this.stepsAudio.playing()) this.stepsAudio.pause();
      //   } else {
      //     if (this.stepsAudio._sounds[0]._paused) this.stepsAudio.play();
      //   }
      // }
    },
    startEndOfLifeProc() {
      this.endClass = true;
      setTimeout(() => {
        this.endClassForContent = true;
      }, 2000);
    },
    pressNext() {
      if (!this.autoPlayState) {
        this.impressNextStep();
      }
    },
    pressPrev() {
      if (!this.autoPlayState) {
        this.impressPrevStep();
      }
    },
    pressNextClick() {
      if (this.canIClick) {
        this.canIClick = false;
        this.impressNextStep();
        setTimeout(() => {
          this.canIClick = true;
        }, 2000);
      }
    },
    pressPrevClick() {
      if (this.canIClick) {
        this.canIClick = false;
        this.impressPrevStep();
        setTimeout(() => {
          this.canIClick = true;
        }, 2000);
      }
    },
    impressNextStep() {
      if (this.sorryMasterCanIGoToOtherSlide) {
        this.slideToGo();
        this.stopSound();
        // let tmpAudioStatus = this.audioVisible;
        if (this.stepsAudio) {
          this.stepsAudio.stop();
        }
        this.audioVisibleMute = false;
        this.$refs.impress.nextStep();
        if (!this.autoPlayState && this.stepsAudio) {
          // console.log('NEXT');
          setTimeout(() => {
            // this.playSound();
            this.stepsAudioController();
          }, 1500);
        }
        this.$store.commit('STATE_SET_CURRENT_STEP', this.$refs.impress.stepClass);
        this.$store.commit('STATE_COMIC_SHOW', false);
        this.createSound();
        // if (this.stepsAudio) {
        //   if (!this.stepsAudio.playing()) {
        //     this.stepsAudio.play();
        //   }
        // }
        this.$store.commit('STATE_AUDIO_WAIT', false);
        this.$store.commit('STATE_SET_GALERY_OPEN', false);
        if (this.currentSlide == 'skip') {
          setTimeout(() => {
            this.impressNextStep();
          }, 1101);
        }
      }
    },
    goToStep(name, index) {
      if (this.canIClick) {
        this.canIClick = false;
        this.stopSound();
        let tmpAudioStatus = this.audioVisible;
        if (this.stepsAudio) {
          this.stepsAudio.stop();
        }
        this.$refs.impress.gotoStep(index);
        this.audioVisibleMute = false;
        if (!this.autoPlayState && this.stepsAudio) {
          setTimeout(() => {
            this.stepsAudioController();
          }, 1500);
        }
        this.$store.commit('STATE_SET_CURRENT_STEP', name);
        this.$store.commit('STATE_COMIC_SHOW', false);
        this.createSound();
        // if (this.stepsAudio) {
        //   if (!this.stepsAudio.playing()) {
        //     this.stepsAudio.play();
        //   }
        // }
        this.$store.commit('STATE_AUDIO_WAIT', false);
        this.$store.commit('STATE_SET_GALERY_OPEN', false);
        setTimeout(() => {
          this.canIClick = true;
        }, 2000);
      }
    },
    info() {
      //console.log('OK');
      ////console.log(window.innerWidth + " : " + window.innerHeight);
      ////console.log((window.innerWidth / window.innerHeight).toFixed(2));
    },
    checkComic() {
      try {
        if (this.slides2[this.$refs.impress.stepIndex].comicControll) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    autoMoveTime(x, index, slideIndex) {
      if (this.slides2[slideIndex].name == 'skip') {
        this.autoMoveTime(x, index, slideIndex + 1);
      } else {
        let time = 5500;
        if (index == 0) {
          time = 3000;
        }
        //console.log(index);
        if (this.autoMove[index].restTime) {
          time = this.autoMove[index].restTime;
        }
        if (this.autoPlayState) {
          setTimeout(() => {
            if (this.autoPlayState) {
              if (this.slides2[slideIndex].audio) {
                this.$store.commit('STATE_AUDIO', true);
                this.$store.commit('STATE_AUDIO_WAIT', true);
                this.$store.commit('STATE_SET_GALERY_OPEN', false);
                if (this.autoPlayState) {
                  this.stepsAudio.play();
                  this.$store.commit('STATE_COMIC_SHOW', true);
                }
              }
            } else {
              return 0;
            }
            setTimeout(() => {
              if (this.autoPlayState) {
                this.$store.commit('STATE_COMIC_SHOW', false);
              } else {
                return 0;
              }
              setTimeout(() => {
                index++;
                slideIndex++;
                if (this.autoMove.length > index && this.autoPlayState) {
                  this.impressNextStep();
                  this.autoMoveTime(this.autoMove[index].time, index, slideIndex);
                } else {
                  return 0;
                }
              }, time);
            }, x);
          }, time);
        } else {
          return 0;
        }
      }
    },
    autoMoves() {
      this.autoMoveTime(this.autoMove[0].time, 0, 0);
    },
    createSteps() {
      let steps = [];
      let clearSteps = [];
      this.slides2.forEach((item, index) => {
        let step = {
          x: item.x || 0,
          y: item.y || 0,
          z: item.z || 0,
          rotateX: item.rotateX || 0,
          rotateY: item.rotateY || 0,
          rotateZ: item.rotateZ || 0,
          scale: 1,
          props: {
            slide: item,
            slideID: item.name,
          },
          transitionDuration: 1000,
          id: item.name,
        };
        if (item.name != 'skip') {
          step.component = baseBoxWithIf;
          clearSteps.push({ name: item.name, id: index });
        }
        if (this.autoPlayState) {
          if (item.name != 'skip') steps.push(step);
        } else {
          steps.push(step);
        }
        if (index == 0) {
          this.$store.commit('STATE_SET_CURRENT_STEP', item.name);
        }
      });
      this.$store.commit('STATE_SET_CLEAR_STEPS', clearSteps);
      this.createSoundForFirstStep();
      return steps;
    },
    pleaseLetMeChooseTheVersion(state, extend) {
      if (extend) {
        this.autoMove = this.$store.getters.getPresentationConfig.autoMoveExtend;
        this.slides2 = this.$store.getters.getPresentationConfig.slidesExtend;
        this.steps = this.createSteps();
      } else {
        this.autoMove = this.$store.getters.getPresentationConfig.autoMove;
        this.slides2 = this.$store.getters.getPresentationConfig.slides;
        this.steps = this.createSteps();
      }
      this.endClass = false;
      this.autoPlayState = state;
      this.$store.commit('STATE_AUTO_MOVE', true);
      if (state) {
        this.autoMoves();
        this.$store.commit('STATE_AUTO_MOVE', false);
      } else {
      }
      if (!this.autoPlayState && this.stepsAudio) {
        setTimeout(() => {
          this.stepsAudioController();
        }, 1500);
      }
    },
    stopSound() {
      try {
        if (this.$refs.impress.stepIndex) {
          if (this.slides2[this.$refs.impress.stepIndex].audio) {
            this.canIPlayASong = true;
            this.$store.commit('STATE_AUDIO_WAIT', false);
            if (this.stepsAudio) this.stepsAudio.stop();
          }
        }
      } catch (err) {
        if (this.slides2[0].audio) {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO_WAIT', false);
          if (this.stepsAudio) this.stepsAudio.stop();
        }
      }
    },
    createSound() {
      if (this.slides2[this.$refs.impress.stepIndex].audio) {
        //console.log(this.slides2[this.$refs.impress.stepIndex].audioPath);
        this.stepsAudio = new Howl({
          src: this.giveMePathPlease(this.slides2[this.$refs.impress.stepIndex].audioPath),
          autoplay: false,
          loop: false,
          volume: 0.2,
          onend: () => {
            this.canIPlayASong = true;
            this.$store.commit('STATE_AUDIO', false);
            if (this.mainAudioControl) {
              // this.sound.fade(0.00, 0.0, 1000);
            }
          },
          onstop: () => {
            this.canIPlayASong = true;
            this.$store.commit('STATE_AUDIO', false);
            // if (this.mainAudioControl) {
            //   this.sound.fade(0.01, 0.1, 1000);
            // }
          },
          onplay: () => {
            // if (this.mainAudioControl) {
            //   this.sound.fade(0.1, 0.01, 1000);
            // }
          },
        });
      } else {
        this.stepsAudio = null;
      }
      //console.log(this.stepsAudio);
    },
    createSoundForFirstStep() {
      if (this.slides2[0].audio) {
        //console.log(this.slides2[0].audioPath);
        this.stepsAudio = new Howl({
          src: this.giveMePathPlease(this.slides2[0].audioPath),
          autoplay: false,
          loop: false,
          volume: 0.2,
          onend: () => {
            this.canIPlayASong = true;
            this.$store.commit('STATE_AUDIO', false);

            // if (this.mainAudioControl) {
            //   this.sound.fade(0.01, 0.1, 1000);
            // }
          },
          onstop: () => {
            this.canIPlayASong = true;
            this.$store.commit('STATE_AUDIO', false);
            // if (this.mainAudioControl) {
            //   this.sound.fade(0.01, 0.1, 1000);
            // }
          },
          onplay: () => {
            this.$store.commit('STATE_AUDIO', true);
            // if (this.mainAudioControl) {
            //   this.sound.fade(0.1, 0.01, 1000);
            // }
          },
        });
      }
      //console.log(this.stepsAudio);
    },

    stepAudioSetMuteValue() {
      //console.log('mute value: ' + !this.audioVisibleMute);
      if (this.stepsAudio) {
        this.stepsAudio.mute(!this.audioVisibleMute);
        this.audioVisibleMute = !this.audioVisibleMute;
      }
    },
    stepsAudioController() {
      if (this.stepsAudio) {
        if (this.stepsAudio.playing()) {
          this.stepsAudio.stop();
          this.$store.commit('STATE_AUDIO', false);
          // console.log('STEPS AUDIO STOP');
        } else {
          this.stepsAudio.play();
          this.$store.commit('STATE_AUDIO', true);
          // console.log('STEPS AUDIO PLAY');
        }
      }
    },
    playSound() {
      // this.$store.commit('STATE_AUDIO', !this.audioVisible);
      if (this.audioVisible) {
        this.canIPlayASong = false;
        this.setAutoAudioRun(true);
      } else {
        this.setAutoAudioRun(false);
      }
    },
    slideToGo() {
      this.sorryMasterCanIGoToOtherSlide = false;
      setTimeout(() => {
        this.sorryMasterCanIGoToOtherSlide = true;
      }, 1100);
    },
    comicInteraction(bind) {
      this.$store.commit('STATE_PRESENTATION_BINDING', bind);
      this.$store.commit('STATE_COMIC_SHOW', !this.showComic);
    },
  },
  beforeDestroy() {
    if (this.$store.getters.realMultibookType) {
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.realMultibookType);
      this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
    }
    if (this.stepsAudio) {
      this.stopSound();
    }
    this.showIndexBook = false;
    this.endClass = true;
    this.autoPlayState = false;
    this.mainAudioControl = false;
    this.$store.commit('STATE_SET_GO_TO', -1);
  },
  computed: {
    // goTo() {
    //   if (this.$store.getters.getPresentationGoTo != -1) {
    //     let stepToGo = this.clearStepsData[this.$store.getters.getPresentationGoTo];
    //     this.goToStep(stepToGo.name, stepToGo.id);
    //   }
    //   return this.$store.getters.getPresentationGoTo;
    // },
    clearStepsData() {
      return this.$store.getters.getPresentationClearSteps;
    },
    mainContenWidth() {
      return 1920 || this.$store.getters.mainContenWidth;
    },
    mainContenHeight() {
      return 1080 || this.$store.getters.mainContenHeight;
    },
    scale() {
      // this.$store.getters.scale || 1
      return this.$store.getters.scale || 1;
    },
    showComic() {
      return this.$store.getters.getComicShow;
    },
    mainBind() {
      return this.$store.getters.getCurrentMainBind;
    },
    audioVisible() {
      return this.$store.getters.getAudio;
    },
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
    galeryOpen() {
      return this.$store.getters.getGaleryOpen;
    },
  },
  beforeMount() {
    this.$store.commit('STATE_SET_GO_TO', -1);
    if (this.$route.name == 'presentation') {
      this.pageScale = Math.min(window.innerWidth / 1920, window.innerHeight / 1080);
      //console.log(this.pageScale);
      this.additionalStyle = {
        transform: 'translate(-50%, -50%) ' + 'scale(1)',
        width: '1920px',
        height: '1080px',
        '-webkit-transform-origin': 'center center',
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
        top: '50%',
        left: '50%',
      };
    }
    this.autoMove = this.$store.getters.getPresentationConfig.autoMove;
    this.slides2 = this.$store.getters.getPresentationConfig.slides;
    this.appConfig = this.$store.getters.getPresentationConfig.conf;
    this.steps = this.createSteps();
  },
  mounted() {
    this.scaleW = this.setWidthScale();
    this.scaleH = this.setHeightScale();
    this.resizeWindow();
    // this.$refs.mbpresentation.focus();
    //this.info();
    if (this.appConfig.mainSound) {
      this.sound = new Howl({
        src: this.giveMePathPlease(this.appConfig.mainSound),
        autoplay: true,
        loop: true,
        volume: this.volume,
      });
    }
    if (this.appConfig.version) {
      //console.log('MAIN_BINDING: ' + this.appConfig.version);
      this.$store.commit('STATE_PRESENTATION_MAIN_BINDING', this.appConfig.version);
    }
    if (this.appConfig.mainSoundStatus == 'off') {
      this.mainAudioControll(!this.mainAudioControl);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      //console.log(from);
    });
  },
  data() {
    return {
      scaleW: 1,
      scaleH: 1,
      scalePres: 1,
      audioVisibleMute: false,
      prevRoute: null,
      canIClick: true,
      hoverControllClose: false,
      hoverControllAudio: false,
      hoverControllIndex: false,
      hoverControllReset: false,
      hoverControllMainAudio: false,
      hoverControllhoverControllMain: false,
      autoAudioRun: true,
      firsStep: true,
      showIndexBook: false,
      canIPlayASong: true,
      volume: 0.02,
      mainAudioControl: true,
      hoverOnPower: false,
      endClass: true,
      sorryMasterCanIGoToOtherSlide: true,
      endClassForContent: true,
      autoPlayState: false,
      autoMove: null,
      slides2: null,
      appConfig: null,
      config: {
        width: 1920,
        height: 1080,
        transitionDuration: 1200,
        perspective: 0,
        fullscreen: true,
      },
      steps: [],
      sound: null,
      stepsAudio: null,
      pageScale: 0,
      additionalStyle: null,
    };
  },
};
</script>

<style lang="sass">
@import './style/base'
@import './style/svg'
@import './style/navigation'
@import './style/animation'
h1
  font-size: 5vw

p
  font-size: 2vw
#mb-presentation
  width: 100%
  height: 100%
  // background: #ffd100
  position: fixed
  z-index: 1000
  top: 0
  left: 0
  overflow: hidden
  background: #f2f2f2
  resize: both
  .mb-presentation-scalable
    box-shadow: 0vh 0vh 2vh .5vh rgba(0,0,0,0.34)
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    background: white
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
  .mbpresentation
    z-index: 1010
    width: 100%
    height: 100%
    top: 0px
    left: 0px
    position: absolute
    overflow: hidden
    background: white

  .btn
    position: fixed
    top: 0
    left: 0
    z-index: 10000
#mb-presentation
  .impress-step
    width: 89%
    height: 89%
    // z-index: -382173612832163879123612
    text-align: center
    cursor: pointer

  .active
    // width: 80%
    // height: 80%
    // z-index: -382173612832163879123612
  .impress-viewport.overview .impress-step:not(.active)
    opacity: 0

  .impress-step.active
    cursor: auto
</style>
